import { getDealInsightsSupportedDateRange } from '@openx/components-deal/lib/DealInsights/utils/getDealInsightsSupportedDateRange';
import { DealInsightsV2Provider } from '@openx/components-deal/lib/DealInsightsV2/context/DealInsightsV2Context';
import { DealInsightsV2 } from '@openx/components-deal/lib/DealInsightsV2/DealInsightsV2';
import { PageHeader } from '@openx/components-header/PageHeader';
import { DEAL_INSIGHTS_V2_ACCESS } from '@openx/constants/feature-flag-keys';
import { Button } from '@openx/design-system/components/Button/Button';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { format } from 'date-fns';
import { Navigate } from 'react-router';

export const DealInsightsV2Page = () => {
  const { isGrowthbookFeatureOn } = usePermissionContext();

  if (!isGrowthbookFeatureOn(DEAL_INSIGHTS_V2_ACCESS)) {
    return <Navigate to="/deal-insights" replace />;
  }

  return (
    <DealInsightsV2Provider>
      <PageHeader
        // the new Deal Insights always uses the design-system header, independent of the future feature flag
        designSystem
        title="Deal Insights"
        // TODO(EXCH-19435): placeholder, not a real value. It is the latest date the date picker allows; replace it with the
        // real last-updated date once it has a data source.
        subtitle={`Data was last updated on ${format(getDealInsightsSupportedDateRange().maxDate, 'MMM d, yyyy')}.`}
        titlePrefix="OpenXSelect"
        sticky
        render={() => (
          // TODO(EXCH-19255): connect PDF export; the old export lives in DealInsights/components/DealInsightsPdfExport
          <Button variant="contained" color="secondary">
            Export PDF
          </Button>
        )}
      >
        <DealInsightsV2 />
      </PageHeader>
    </DealInsightsV2Provider>
  );
};
